import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Layout/Footer";
import Navbar from "../Layout/Navbar";

const MLPage = () => {
  document.title = "Carte Verte : Mentions Légales";

  return (
    <div>
      <div className="site-header">
        <div className="container">
          <Navbar />
        </div>
      </div>
      <div className="container mlContainer">
  <section className="spaced">
          <h1>
            Mentions{" "}
            <span style={{ whiteSpace: "nowrap" }}>
              légales <span className="point"></span>
            </span>
          </h1>
          <ul style={{ marginBottom: "1rem" }}>
            {/* <li>SAS au capital de 300 000 €</li>
            <li>
              <strong>Siège social</strong> : 16 Rue Emile Baudot 91120
              Palaiseau
            </li>
            <li>
              <strong>Numéro de TVA intracommunautaire</strong> : FR20451234567
            </li>
            <li>
              <strong>Numéro de déclaration CNIL</strong> : 1001234
            </li> */}
            <li>
              <strong>Réalisation</strong> : CARTE VERTE.
            </li>
            <li>
              <strong>Directeur de la publication</strong> : M. Kimouche.
            </li>
            <li>
              <strong>Responsable de la rédaction</strong> : M. Kimouche.
            </li>
            <li>
              <strong>Pour nous contacter</strong> :{" "}
              <Link
                to="/#contactUs"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "inline-block", margin: "0" }}
              >
                www.carteverte.co/contact
              </Link>
            </li>
            <li>
              <strong>Hébergement</strong> : Netlify, Inc., 2325 3rd St #215,
              San Francisco - https://www.netlify.com
            </li>
          </ul>

          <p>
            Le site
            <Link to="http://www.carteverte.co" target="_blank" rel="noopener noreferrer">
              {' '}
              carteverte.co
            </Link>{' '}
            et l'application web que vous consultez sont des services en ligne
            proposant une solution de carte de fidélité.
          </p>
        </section>
  <section className="spaced">
          <h1>
            L'utilisation des supports édités par{" "}
            <span style={{ whiteSpace: "nowrap" }}>
              Carte Verte <span className="point"></span>
            </span>
          </h1>
          <p>
            Les marques de Carte Verte, ainsi que les logos figurant sur le site
            sont des marques déposées. Toute reproduction ou représentation
            totale ou partielle de ces marques ou de ces logos, seules ou
            intégrées à d'autres éléments, sans l'autorisation expresse et
            préalable est prohibée, et engagerait la responsabilité de
            l'utilisateur au sens des articles L. 713-2 et L.713-3 du Code de la
            Propriété Intellectuelle. Toute reproduction, représentation,
            modification, publication, transmission, dénaturation, totale ou
            partielle du site ou de son contenu, par quelque procédé que ce
            soit, est interdite.
          </p>
          <p>
            La société Carte Verte ne pourra en aucun cas être responsable en
            cas de dommages directs et/ou indirects résultant de
            l'utilisation&nbsp;des supports édités par Carte Verte&nbsp;ou de
            l'impossibilité d'accéder à ces supports.
          </p>
          <h2>Accès à l'application Carte Verte :</h2>
          <p>
            Vos clients doivent télécharger l'application Carte Verte sur leur
            téléphone afin de pouvoir ajouter votre commerce à leur
            portefeuille et ainsi commencer à profiter des avantages de
            fidélité.
          </p>

          <h2>Participer aux enquêtes proposées par Carte Verte :</h2>
          <p>
            Tout client de Carte Verte peut participer, à titre gracieux et sans
            contrepartie d'aucune nature, aux enquêtes, sous réserve d'être
            majeur. L'Utilisateur certifie et garantit l'exactitude des données
            transmises et déclare être propriétaire des droits et/ou
            autorisations nécessaires relatifs aux droits d'auteur ou droit de
            propriété intellectuelle et/ou industrielles.
          </p>
          <br />
          <p>
            L'Utilisateur s'engage à ne pas diffuser de données illégales,
            contraires à l'ordre public et aux bonnes moeurs, à caractère
            injurieux, diffamatoire, xénophobe, incitant à la haine, portant
            atteinte à l'honneur, à la réputation ou aux droits d'autrui. Tout
            manquement à cet engagement entrainera 1/ la suppression par Carte
            Verte de la publication des Données de l'Utilisateur, 2/ la
            notification motivée de l'Utilisateur par Carte Verte et 3/ obligera
            l'Utilisateur à relever et garantir Carte Verte de toute réclamation
            de tiers.
          </p>
          <p>
            En dehors des cas prévus ci-dessus, les données communiquées par les
            participations aux enquêtes seront publiées par Carte Verte dans un
            délai de 1 mois commençant à la date de validation du formulaire par
            le participant. Ces données resteront publiées sur le site de Carte
            Verte pendant une période de 24 mois.
          </p>
        </section>

  <section className="spaced">
          <h1 id="dataPrivacy">
            Protection des{" "}
            <span style={{ whiteSpace: "nowrap" }}>
              données <span className="point"></span>
            </span>
          </h1>
          <p>
            Les informations recueillies sur ce site sont enregistrées dans un
            fichier informatisé par Carte Verte pour :
          </p>
          <ul>
            <li>
              - Gérer la commercialisation, la gestion et la facturation des
              abonnements vendus aux clients.
            </li>
            <li>- Recueillir vos avis sur l'utilisation du service.</li>
            <li>
              - Vous envoyer des informations sur nos produits et services
              uniquement si vous le demandez.
            </li>
          </ul>
          <br />
          <p>
            Ces informations sont strictement limitées aux informations
            communiquées lors de la souscription ou de la demande d'envoi
            d'informations et aux informations relatives à l'usage qui est fait
            des services de Carte Verte. Ces informations sont restreintes aux
            données nécessaires à la gestion du service : exécution du service,
            maintenance, correction, proposition d'évolution du service pour
            l'adapter aux usages, réponses apportées aux questions, réponse aux
            obligations légales et facturation.
          </p>
        </section>
        <section className="spaced">
          <h1 id="ads">
            À propos des{" "}
            <span style={{ whiteSpace: "nowrap" }}>
              pubs <span className="point"></span>
            </span>
          </h1>
          <p>Le site Carte Verte est neutre en matière de publicité.</p>
        </section>
        <section className="spaced">
          <h1 id="cookies">
            Informations concernant l'utilisation des{" "}
            <span style={{ whiteSpace: "nowrap" }}>
              cookies <span className="point"></span>
            </span>
          </h1>

          <p>
            Les « cookies » sont l'ensemble des traceurs déposés ou lus lors de
            la consultation de nos sites internet. Ceci comprend les cookies
            http, les balises également appelées « pixels invisibles » et « web
            bugs », les scripts ou encore le résultat du calcul d'empreinte dans
            le cas du « fingerprinting ».
          </p>

          <h2>Qu'est-ce qu'un cookie ?</h2>
          <p>
            Un cookie est un petit fichier informatique, qui peut être transmis
            par des sites via votre navigateur. Ces cookies sont conservés sur
            votre terminal (ordinateur, smartphone, tablette…) lorsque vous
            consultez certains sites web. Les cookies permettent notamment de
            stocker et de récupérer des informations concernant les habitudes de
            navigation de l'utilisateur d'un site ou de son équipement puis, en
            fonction de ces informations, de le reconnaître.
          </p>

          <h2>Qu'est-ce qu'une balise web ?</h2>
          <p>
            Autrement appelée « pixel tag », « pixel invisible », « clear GIFs
            », « web bugs » ou encore « web beacons », la balise web est un bout
            de code autonome ou une image présente sur certaines pages aux fins
            de contrôle et de suivi du trafic.
          </p>

          <h2>Qu'est-ce que le calcul d'empreinte ?</h2>
          <p>
            Le calcul d'empreinte ou « fingerprinting » permet la création d'un
            identifiant unique de la machine qui consulte une page web, basé sur
            des éléments de sa configuration à des fins de suivi.
          </p>
        </section>

  <section className="spaced">
          <h1 className="wpx_no-m">
            Sur notre site, il y a un seul type de{" "}
            <span style={{ whiteSpace: "nowrap" }}>
              cookies <span className="point"></span>
            </span>
          </h1>
          <h2>Cookies fonctionnels</h2>
          <p>
            Ce sont les cookies indispensables au bon fonctionnement de notre
            site internet (connexion aux différents espaces réservés du site,
            optimisation technique, sécurisation, correction des éventuels
            problèmes, commande via notre boutique, ...). Conformément à la
            règlementation, ces cookies sont utilisés sans nécessiter votre
            consentement car ils ont pour finalité exclusive de permettre et de
            faciliter la communication par voie électronique.
          </p>
        </section>
  <section className="spaced">
          <h1>
            Démarche à suivre pour supprimer les{" "}
            <span style={{ whiteSpace: "nowrap" }}>
              cookies <span className="point"></span>
            </span>
          </h1>
          <ul>
            <li>
              <b>Mozilla firefox</b> :
              <a
                href="https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox-ordinateur?redirectlocale=fr&amp;redirectslug=activer-desactiver-cookies#_blank"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span style={{ textDecoration: "underline" }}>cliquez ici</span>.
              </a>
            </li>
            <li>
              <b>Internet Explorer</b> :
              <a
                href="https://support.microsoft.com/fr-fr/topic/supprimer-et-g%C3%A9rer-les-cookies-168dab11-0753-043d-7c16-ede5947fc64d#_blank"
                target="_blank" 
                rel="noopener noreferrer"
              >
                {" "}
                <span style={{ textDecoration: "underline" }}>cliquez ici</span>.
              </a>
            </li>
            <li>
              <b>Chrome</b> :
              <a
                href="https://support.google.com/chrome/answer/95647?hl=fr&amp;hlrm=en#_blank"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span style={{ textDecoration: "underline" }}>cliquez ici</span>.
              </a>
            </li>
            <li>
              <b>Safari</b> :
              <a
                href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span style={{ textDecoration: "underline" }}>cliquez ici</span>.
              </a>
            </li>
          </ul>
        </section>
  <section className="spaced">
          <h1>
            Plus d'informations sur les cookies avec la{" "}
            <span style={{ whiteSpace: "nowrap" }}>
              CNIL <span className="point"></span>
            </span>
          </h1>
          <ul>
            <li>
              Démarches à suivre pour limiter vos <b>traces sur le web</b> :
              <a
                href="https://www.cnil.fr/fr/cookies-et-autres-traceurs/comment-se-proteger/maitriser-votre-navigateur"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span style={{ textDecoration: "underline" }}>cliquez ici</span>.
              </a>
            </li>
            <li>
              Outil de visualisation qui identifie en temps réel les{" "}
              <b>cookies</b> qui transmettent des informations :
              <a
                href="https://linc.cnil.fr/fr/cookieviz-une-dataviz-en-temps-reel-du-tracking-de-votre-navigation#_blank"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span style={{ textDecoration: "underline" }}>cliquez ici</span>.
              </a>
            </li>
          </ul>
        </section>
      </div>
      <Footer></Footer>
    </div>
  );
};

export { MLPage as default };
